import React, { useEffect, useRef } from 'react';
import './Hero.scss';
import { gsap } from '../../gsap';
import contents from '../../contents';
// import logoImg from "../../assets/logo.png";
// import videoLoopD from "../../assets/hero-desktop.mp4";
// import videoLoopM from "../../assets/hero-mobile.mp4";

//delete logoImg/videoLoopD/videoLoopM below if importing logo image and video loop assets above
//otherwise replace the urls
// const logoImg = 'https://component-library-assets.s3.amazonaws.com/logo.svg';
import logoImg from '../../Assets/logoLockup.png';
const videoLoopD =
  'https://courageous-cdn-media-bucket.s3.amazonaws.com/intelWonderful/millersLandingHero.mp4';
const videoLoopM =
  'https://courageous-cdn-media-bucket.s3.amazonaws.com/intelWonderful/millersLandingHeroM.mp4';

const heroContent = contents.hero;

function Hero({
  handleMouseLeaveTooltip,
  handleMouseEnterTooltip,
  heroBackgroundType,
  logoPlacement
}) {
  const logoTooltip = useRef();
  const videoLoopRef = useRef();
  const heroBgType = heroBackgroundType ? heroBackgroundType : contents.hero.background;
  const logoPl = logoPlacement ? logoPlacement : contents.hero.logoPlacement;

  useEffect(() => {
    gsap.fromTo('#logo', { opacity: 0 }, { opacity: 1, duration: 0.7, delay: 0.5 });
    gsap.fromTo('#title', { opacity: 0 }, { opacity: 1, duration: 0.7, delay: 0.8 });
    gsap.fromTo('#subTitle', { opacity: 0 }, { opacity: 1, duration: 0.7, delay: 1.1 });
  }, []);

  useEffect(() => {
    if (heroBgType === 'video') {
      videoLoopRef.current.play();
    }
  }, [heroBgType]);

  return (
    <section className={heroBgType === 'video' ? 'hero' : 'hero hero--image'}>
      <div className="hero__overlay" />
      {heroBgType === 'video' ? (
        <div className="hero--videoLoop">
          <video
            autoPlay
            muted
            playsInline
            loop
            className="hero--videoLoop__video"
            ref={videoLoopRef}
          >
            <source media="(min-width:481px)" src={videoLoopD} type="video/mp4" />
            <source media="(max-width:480px)" src={videoLoopM} type="video/mp4" />
            Your browser does not support HTML5 video.
          </video>
        </div>
      ) : (
        <></>
      )}
      {logoPl === 'top' ? (
        <div className="hero__logo hero__logo--top" id="logo">
          <a href={contents.logoTooltip.href} target="_blank" rel="sponsored noopener">
            <img
              className="hero__logo__img"
              src={logoImg}
              alt="logo"
              onMouseEnter={(e) => {
                handleMouseEnterTooltip(e, logoTooltip);
              }}
              onMouseLeave={() => {
                handleMouseLeaveTooltip(logoTooltip);
              }}
            />
          </a>
          <div className="tooltip" ref={logoTooltip}>
            <p className="tooltip__content">{contents.logoTooltip.copy}</p>
          </div>
        </div>
      ) : (
        <></>
      )}
      <div className="hero__contents">
        <div className="hero__contents__titleBox">
          {logoPl === 'center' ? (
            <div className="hero__logo hero__logo--center" id="logo">
              <a href={contents.logoTooltip.href} target="_blank" rel="sponsored noopener">
                <img
                  className="hero__logo__img"
                  src="https://component-library-assets.s3.amazonaws.com/logo.svg"
                  alt="logo"
                  onMouseEnter={(e) => {
                    handleMouseEnterTooltip(e, logoTooltip);
                  }}
                  onMouseLeave={() => {
                    handleMouseLeaveTooltip(logoTooltip);
                  }}
                />
              </a>
              <div className="tooltip" ref={logoTooltip}>
                <p className="tooltip__content">{contents.logoTooltip.copy}</p>
              </div>
            </div>
          ) : (
            <></>
          )}

          <h1 className="hero__contents__titleBox__title" id="title">
            {heroContent.title}
          </h1>
          <h2 className="hero__contents__titleBox__subTitle" id="subTitle">
            {heroContent.copy}
          </h2>
        </div>
      </div>
      {/* <div
        className="hero__wfhLogo"
        // style={{ position: 'absolute', top: '2rem', right: '2rem', width: '130px' }}
      >
        <img src={wfhLogo} style={{ width: '100%' }} alt="work from humankind logo" />
      </div> */}
    </section>
  );
}

export default Hero;
